import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import { parseRmaLineDTO, RmaLineDTO } from 'components/ordering/rma/api/dtos/rma-line-dto.js'


export type IRmaDraftDTO = {
  id: string
  party: number
  user: number
  shop: number
  state: string
  status: string
  lines: unknown
  comment: string | null
}


export class RmaDraftDTO {
  id: string
  party: number
  user: number
  shop: number
  state: string
  status: string
  lines: RmaLineDTO[]
  comment: string | null

  constructor(data: IRmaDraftDTO) {
    this.id = data.id
    this.party = data.party
    this.user = data.user
    this.shop = data.shop
    this.state = data.state
    this.status = data.status
    this.lines = (data.lines as unknown[]).map(parseRmaLineDTO)
    this.comment = data.comment
  }
}


const validate = createValidate<IRmaDraftDTO>()

export const parseRmaDraftDTO = (data: unknown): RmaDraftDTO | null => {
  if (data === null) return null
  validateGuard(validate, data, 'rma draft')
  return new RmaDraftDTO(data)
}

export const parseDefiniteRmaDraftDTO = (data: unknown): RmaDraftDTO => {
  const draft = parseRmaDraftDTO(data)
  if (draft === null) throw new Error('Expected rma draft but received null')
  return draft
}
